import { Flex, rem, Skeleton } from '@mantine/core';
import { DataPersonTct } from '@dealstack/shared/lib/generated';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { InvestorDetailsCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/InvestorDetailsCard/InvestorDetailsCard.tsx';
import { InvestmentVehicleItem } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/InvestmentVehiclesCard/InvestmentVehicleItem.tsx';
import { DetailsCardEmptyState } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DetailsCardEmptyState.tsx';

interface Props {
	dealId: string;
	mipId: string;
	vehicles: DataPersonTct[] | undefined;
	isLoading?: boolean;
	isError?: boolean;
}

export const InvestmentVehiclesCard = ({
	dealId,
	mipId,
	vehicles = [],
	isLoading = false,
	isError = false,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	if (isLoading) {
		return <Skeleton height={rem(204)} radius="0.5rem" />;
	}

	const renderContent = () => {
		// A failed investor fetch must not read as "invests as an individual".
		if (isError) {
			return (
				<DetailsCardEmptyState message={tMipManage('investors.details.card_load_error')} />
			);
		}

		if (!vehicles.length) {
			return (
				<DetailsCardEmptyState
					message={tMipManage('investors.details.vehicles_card.empty')}
				/>
			);
		}

		return (
			<Flex direction="column" gap="0.25rem">
				{vehicles.map((vehicle) => (
					<InvestmentVehicleItem
						key={vehicle.id}
						dealId={dealId}
						mipId={mipId}
						vehicle={vehicle}
					/>
				))}
			</Flex>
		);
	};

	return (
		<InvestorDetailsCard
			title={tMipManage('investors.details.vehicles_card.title')}
			count={vehicles.length}
			action={{ kind: 'expand', defaultExpanded: !!vehicles.length }}
			dataTestId={TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_VEHICLES_CARD}
		>
			{renderContent()}
		</InvestorDetailsCard>
	);
};
